import {React ,useEffect} from "react";
import { FiLinkedin, FiInstagram, FiGithub } from "react-icons/fi";
import { AiOutlineCopyright } from "react-icons/ai";
import { BiMoon, BiSun } from "react-icons/bi";
function Fotter(props) {
 
  return (
    <div>
      <div className=" fotter pt-[80px] md:mt-16 lg:mt-0 lg:h-[320px] bg-deep font-Poppins size={20} text-[#ffffff] realtive  h-[480px] w-[100%]">
        <div className="flex  lg:flex-row  flex-col items-center justify-center mx-auto  lg:space-x-28 space-y-12  w-[100%]">
          <div className=" flex flex-col space-y-3">
            <p className=" text-5xl font-Poppinsb">Tanmay</p>
            <p className=" opacity-75">Full stack Developer</p>
          </div>
          <div className=" flex flex-row space-x-3">
            <ul className="flex  space-x-6 ">
              <li className=" ">
                <a href="#">Home</a>
              </li>
              <li className=" ">
                <a href="#About">About</a>
              </li>
              <li className=" ">
                <a href="#ContactMe">Contact</a>
              </li>
            </ul>
          </div>
          <div className="flex flex-row space-x-6">
            <a
              href="https://www.linkedin.com/in/tanmay-kumar-438403222/"
              target="_blank"
            >
              <FiLinkedin size={20} />
            </a>
            <a href="https://www.instagram.com/_.tanmay_28/ " target="_blank">
              <FiInstagram size={20} />
            </a>
            <a href="https://github.com/tanmay2809" target="_blank">
              <FiGithub size={20} />
            </a>
          </div>
        </div>
        <div className="  flex flex-row mx-auto items-center justify-center text-[#e4dcdc] pt-[90px]">
          <AiOutlineCopyright />
          <span className=" opacity-75">Tanmay. All rights reserved</span>
        </div>
      </div>
      
    </div>
  );
}

export default Fotter;
